module.exports = __webpack_public_path__ + "static/media/people.7484190d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/services/transport/people.png
// module id = 150
// module chunks = 0 4